import { render } from "./Age.vue?vue&type=template&id=68f895ed&scoped=true"
import script from "./Age.vue?vue&type=script&lang=js"
export * from "./Age.vue?vue&type=script&lang=js"

import "./Age.vue?vue&type=style&index=0&id=68f895ed&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68f895ed"]])

export default __exports__